function compareString(str1, str2) {
    return (str1 === null || str1 === void 0 ? void 0 : str1.toLowerCase()) === (str2 === null || str2 === void 0 ? void 0 : str2.toLocaleLowerCase());
}

export { compareString };
//# sourceMappingURL=compareString.js.map
